import React from "react";
import { createRoot } from "react-dom/client";
import {BrowserRouter} from "react-router-dom";
import { Provider } from "react-redux";
import { store } from './redux/configureStore';
import 'react-app-polyfill/ie11';
import moment from 'moment';
import 'moment/locale/ru';
import App from "./core/App";

moment.locale('ru');

// Версионность теперь обрабатывается в useAppVersion хуке

localStorage.removeItem('payProcessing');

if (document.location.protocol === 'https:') {
	caches.keys().then(function(names) {
		for (let name of names) {
			console.log(name, 'cache name')
			caches.delete(name).then(res => console.log('cache is cleared?', res));
		}
	})
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <BrowserRouter basename={"/"}>
            <App />
        </BrowserRouter>
    </Provider>
);
